import { useEventListener } from 'ahooks';
import { useCallback, useRef } from 'react';

interface PromiseTask<T = any> {
  task: () => Promise<T>;
  resolve: (res: T) => void;
  reject: () => void;
}

function useFocusTask() {
  const focusTasksRef = useRef<PromiseTask[]>([]);

  useEventListener('focus', () => {
    if (focusTasksRef.current.length === 0) {
      return;
    }

    focusTasksRef.current.forEach(({ task, resolve, reject }) => {
      task().then(resolve).catch(reject);
    });

    focusTasksRef.current = [];
  });

  const executeFocusTask = useCallback(<T>(task: () => Promise<T>) => {
    if (document.hasFocus()) {
      return task();
    }

    return new Promise<T>((resolve, reject) => {
      focusTasksRef.current.push({
        task,
        resolve,
        reject,
      });
    });
  }, []);

  return {
    focusTasksRef,
    executeFocusTask,
  };
}

export default useFocusTask;
